"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRisks = createRisks;
const events_1 = require("../../../events");
const smoking_1 = require("../../../forms/htx/risks/smoking");
const shared_1 = require("../../shared");
const createAlcohol_1 = require("./createAlcohol");
const queries_1 = require("../queries");
const messages = {
    risks: {
        id: "dashboard.risks",
        defaultMessage: "Rizikófaktorok"
    },
    mentalHealthReview: {
        id: "dashboard.mental_health_review",
        defaultMessage: "Pszichológiai felmérés"
    },
    socialWorkerReview: {
        id: "dashboard.social_worker_review",
        defaultMessage: "Környezettanulmány"
    },
    smoke: {
        id: "dashboard.smoke",
        defaultMessage: "Dohányzik"
    }
};
function createRisks(intl, options) {
    const smoking = createSmoking(intl, options);
    const mentalHealthReview = createMentalHealthReview(intl, options);
    const socialWorkerReview = createSocialWorkerReview(intl, options);
    const alcohol = (0, createAlcohol_1.createAlcohol)(intl, options);
    const content = (0, shared_1.createSectionContent)([
        smoking,
        alcohol,
        mentalHealthReview,
        socialWorkerReview
    ]);
    return (0, shared_1.createSection)(intl, { label: messages.risks, content });
}
function createSmoking({ formatMessage }, { events }) {
    const event = (0, events_1.findLastEventByQuery)(events, queries_1.queries.smoking);
    if (event === undefined || event.value === smoking_1.CurrentlySmoking.NO) {
        return undefined;
    }
    const { timestamp, sid, origin } = event;
    return {
        type: "record",
        attachments: (0, events_1.mapEventsToAttachments)(event),
        value: formatMessage(messages.smoke),
        timestamp,
        sid,
        origin
    };
}
function createMentalHealthReview(intl, { events }) {
    return (0, shared_1.createStringRecord)(intl, {
        events,
        variant: "long",
        label: messages.mentalHealthReview,
        query: queries_1.queries.mentalHealthReview
    });
}
function createSocialWorkerReview(intl, { events }) {
    return (0, shared_1.createStringRecord)(intl, {
        events,
        variant: "long",
        label: messages.socialWorkerReview,
        query: queries_1.queries.socialWorkerReview
    });
}
